module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-alpha-up-b7401b65.svg";